import { loadScript } from '@honeybook/utils-web';
import { RemoteAppData } from './types';

export function initRemoteApp(appData: RemoteAppData) {
    // Segment
    if (appData.segment && window.isProduction) {
        loadScript({
            id: 'segment',
            type: 'text/javascript',
            charset: 'utf-8',
            textContent: `
                !(function () {
                    var segmentKey = '${appData.segment.key}';
                    var analytics = (window.analytics =
                        window.analytics || []);
                    if (!analytics.initialize)
                        if (analytics.invoked)
                            window.console &&
                                console.error &&
                                console.error(
                                    'Segment snippet included twice.'
                                );
                        else {
                            analytics.invoked = !0;
                            analytics.methods = [
                                'trackSubmit',
                                'trackClick',
                                'trackLink',
                                'trackForm',
                                'pageview',
                                'identify',
                                'reset',
                                'group',
                                'track',
                                'ready',
                                'alias',
                                'debug',
                                'page',
                                'once',
                                'off',
                                'on',
                                'addSourceMiddleware',
                                'addIntegrationMiddleware',
                                'setAnonymousId',
                                'addDestinationMiddleware'
                            ];
                            analytics.factory = function (e) {
                                return function () {
                                    var t =
                                        Array.prototype.slice.call(
                                            arguments
                                        );
                                    t.unshift(e);
                                    analytics.push(t);
                                    return analytics;
                                };
                            };
                            for (
                                var e = 0;
                                e < analytics.methods.length;
                                e++
                            ) {
                                var key = analytics.methods[e];
                                analytics[key] =
                                    analytics.factory(key);
                            }
                            analytics.load = function (key, e) {
                                var t =
                                    document.createElement(
                                        'script'
                                    );
                                t.type = 'text/javascript';
                                t.async = !0;
                                t.src =
                                    'https://hscm.honeybook.com/analytics.js/v1/' +
                                    key +
                                    '/analytics.min.js';
                                var n =
                                    document.getElementsByTagName(
                                        'script'
                                    )[0];
                                n.parentNode.insertBefore(t, n);
                                analytics._loadOptions = e;
                            };
                            analytics._writeKey = segmentKey;
                            analytics.SNIPPET_VERSION = '4.15.3';
                            analytics.load(segmentKey, {
                                integrations: {
                                    'Segment.io': {
                                        deliveryStrategy: {
                                            config: {
                                                keepalive: true
                                            }
                                        },
                                        apiHost: "hsam.honeybook.com/v1"
                                    }
                                }
                            });
                            analytics.page();
                        }
                })();
            `
        });
    }
}

export function initRemoteAppWithManifestData({
    appData,
    buildVersion
}: {
    appData: RemoteAppData;
    buildVersion: string;
}) {
    // Datadog
    if (appData.datadog) {
        loadScript({
            id: 'datadog',
            type: 'text/javascript',
            charset: 'utf-8',
            textContent: `
                if (window.isProduction) {
                    (function (h, o, u, n, d) {
                        h = h[d] = h[d] || { q: [], onReady: function (c) { h.q.push(c) } };
                        d = o.createElement(u); d.async = 1; d.src = n;
                        n = o.getElementsByTagName(u)[0]; n.parentNode.insertBefore(d, n);
                    })(window, document, 'script', 'https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js', 'DD_RUM');

                    function getSessionReplaySampleRate() {
                        if (${!appData.datadog.rum.logicConfig
                            ?.sessionReplaySampleRate}) {
                            return undefined;
                        } else if (hb_isMobileApp()) {
                            return ${
                                appData.datadog.rum.logicConfig
                                    ?.sessionReplaySampleRate.mobileApp
                            };
                        } else {
                            return ${
                                appData.datadog.rum.logicConfig
                                    ?.sessionReplaySampleRate.web
                            };
                        }
                    }
                    var sessionReplaySampleRate = getSessionReplaySampleRate();

                    var defaultRumConfig = {
                        site: 'datadoghq.com',
                        env: 'prod',
                        trackUserInteractions: true,
                        defaultPrivacyLevel: 'mask-user-input',
                        allowedTracingUrls: ['https://api.honeybook.com'],
                        beforeSend: window.ddBeforeSend
                    }
                    var rumConfig = Object.assign(
                        defaultRumConfig,
                        ${JSON.stringify(appData.datadog.rum.rawConfig)},
                        {
                            version: '${buildVersion}'
                        },
                        {
                            ...(sessionReplaySampleRate !== undefined ? { sessionReplaySampleRate } : {}),
                        }
                    );
                    window.DD_RUM.onReady(function() {
                        window.DD_RUM.init(rumConfig);
                    });

                    (function (h, o, u, n, d) {
                        h = h[d] = h[d] || { q: [], onReady: function (c) { h.q.push(c) } };
                        d = o.createElement(u); d.async = 1; d.src = n;
                        n = o.getElementsByTagName(u)[0]; n.parentNode.insertBefore(d, n);
                    })(window, document, 'script', 'https://www.datadoghq-browser-agent.com/us1/v5/datadog-logs.js', 'DD_LOGS');

                    var defaultLogsConfig = {
                        site: 'datadoghq.com',
                        env: 'prod',
                        silentMultipleInit: true,
                        useCrossSiteSessionCookie: true
                    }
                    var logsConfig = Object.assign(
                        defaultLogsConfig,
                        ${JSON.stringify(appData.datadog.logs)}
                    );
                    DD_LOGS.onReady(function() {
                        DD_LOGS.init(logsConfig);
                    });
                } else {
                    window.DD_RUM = new Proxy({},{get:()=>()=>{}})
                }
            `
        });
    }
}
